import { useRef, useState } from "react";
import { useHomeAnimations, useNormalizeScroll } from "animations";
import { Article, Hero, ImageNavigation, YouTubeModal } from "components";
import Carousel from "components/Carousel/Carousel";
import {
  slideOne,
  gridOne,
  gridTwo,
  gridThree,
  gridFour,
  slideTwo,
  slideThree,
  slideFour,
  slideFive,
  slideSix,
  slideSeven,
  slideEight,
  slideNine,
} from "assets/images";
import styles from "./Home.module.scss";
import { isDesktop } from "utils/isDesktop";

const Home = () => {
  const ref = useRef(null);
  useNormalizeScroll();
  useHomeAnimations(ref);

  const carouselHeader = (
      <>
        Don't take it from us. Take it from the forward-thinkers that trust our{" "}
        <span>Precision Construction</span> tools to solve their problems, or
        avoid them altogether.
      </>
    ),
    slides = [
      {
        img: { src: slideOne, width: "900", height: "543" },
        quote:
          "“It really made production and our numbers go through the roof.”",
        name: "Will Grimes",
        role: "Equipment Manager, Southern Site Contractors",
      },
      {
        img: { src: slideTwo, width: "900", height: "543" },
        quote: "“No matter where you put the blade it stays on grade.”",
        name: "Ryan Chrisman",
        role: "Operator, Sporer Land Development",
      },
      {
        img: { src: slideThree, width: "900", height: "543" },
        quote: "“About backed into a pile… camera saved me.”",
        name: "Bob Haun",
        role: "Operator, Tricon Materials",
      },
      {
        img: { src: slideFour, width: "900", height: "543" },
        quote:
          "“With one glance of the phone I can tell you everything I need to know about our equipment fleet.”",
        name: "Ryan Clinard",
        role: "Division President, Southern Site Contractors",
      },
      {
        img: { src: slideFive, width: "900", height: "543" },
        quote:
          "“You can make that machine do anything you want to with doing nothing more than moving your fingertips.”",
        name: "Darin Stroud",
        role: "Project Superintendent, Hammett Excavation",
      },
      {
        img: { src: slideSix, width: "900", height: "543" },
        quote: "“It‘s like having a guardian angel looking over your fleet.”",
        name: "Larry Leclair",
        role: "Equipment Manager, AJ Johns",
      },
      {
        img: { src: slideSeven, width: "900", height: "543" },
        quote:
          "“Maybe our operators are riding the brakes or maybe there's a low tire and we haven't sensed it yet. But the machine monitoring process is already catching that before it turns into a problem.”",
        name: "Jay Lemon",
        role: "Co-owner, Haskell Lemon Construction",
      },
      {
        img: { src: slideEight, width: "900", height: "543" },
        quote:
          "“We had an instance where the non-tech asphalt company was telling us we were off, and we were where we were supposed to be. Digital is always going to be spot on.”",
        name: "Marty Coppock",
        role: "VP Operations, Rock N Dirt",
      },
      {
        img: { src: slideNine, width: "900", height: "543" },
        quote:
          "“How we better utilize technologies that are available to us is how we make informed and smart decisions to make our jobsites safe.”",
        name: "Fahteema Parish",
        role: "President/CEO, Parrish and Sons Construction",
      },
    ],
    articleContent = [
      {
        title: "Grade Management | John Deere",
        body: "We know how over-grading, changes in work scope, understaffing and lack of time add up to rework. That's why our flexible grade-management tools are engineered to minimize rework, or avoid it altogether. To boost productivity, and the bottom line. With fewer passes, and less downtime, John Deere grade control solutions levels the dirt and the work that keeps you NEVER IDLE.",
        src: gridOne,
        width: 603,
        height: 339,
        video: { src: "https://www.youtube.com/embed/avJGzvvoQ_8" },
        action: {
          title: "Watch Now",
        },
      },
      {
        title: "Obstacle Detection | John Deere",
        body: "No one ever said safety second. It's especially important to be alert given that the jobsite is never the same two days in a row. SmartDetect helps your machine be on the lookout for you. It uses a combination of cameras, radar, and machine learning to give you eyes in the back of your head. Protect your crew and other investments like never before.",
        src: gridTwo,
        width: 603,
        height: 339,
        video: { src: "https://youtube.com/embed/Jd4tfBk56zs" },
        action: {
          title: "Watch Now",
        },
      },
      {
        title: "John Deere Innovation",
        body: "At John Deere, we innovate on behalf of our customers because what we learn is not a byproduct of what we do. It's the fuel that powers what we can do better.",
        src: gridThree,
        width: 603,
        height: 339,
        action: {
          title: "Learn More",
          href: "https://about.deere.com/en-us/our-company-and-purpose/technology-and-innovation",
        },
      },
      {
        title: "Precision Construction",
        body: "Learn about the latest developments in our commitment to keep customers on the cutting edge of construction technology solutions.",
        src: gridFour,
        width: 603,
        height: 339,
        action: {
          title: "Download Brochure",
          href: "https://www.deere.com/assets/pdfs/common/products/worksight-dkwsight.pdf",
        },
        actionTwo: {
          title: "Browse John Deere Tech Articles",
          href: "https://www.deere.com/en/news/all-news/?bin=type::article,topic::Technology",
        },
      },
    ];

  const [heroModal, _openHeroModal] = useState(false),
    openHeroModal = () => {
      _openHeroModal(true);
    },
    closeHeroModal = () => {
      _openHeroModal(false);
    };

  return (
    <div ref={ref} id={styles.home}>
      <Hero
        title="WE BUILD TOOLS"
        content="And we know that any tool you add to your machine needs to put in the work and earn its keep. That’s why from day one, our approach to tech has been to help you work smarter, not harder, to tackle whatever the jobsite throws at you."
        bg="home"
        paused={heroModal}
        home={
          isDesktop ? (
            <>
              <button
                className={styles.button}
                onClick={openHeroModal}
                aria-label="watch smarter tools in action"
              >
                <span>WATCH Smarter Tools</span> <span>in Action</span>
              </button>
              <div className={styles.down} />
            </>
          ) : (
            <>
              <a
                className={styles.button}
                href="https://www.youtube.com/embed/QylONQ-aDrY"
                target="_blank"
                rel="noreferrer"
                aria-label="watch smarter tools in action"
              >
                WATCH Smarter Tools in Action
              </a>
              <div className={styles.down} />
            </>
          )
        }
      />
      {isDesktop && (
        <YouTubeModal
          href="https://www.youtube.com/embed/QylONQ-aDrY"
          open={heroModal}
          closeModal={closeHeroModal}
        />
      )}
      <section className={styles["carousel-section"]}>
        <div className={styles.bg} />
        <h4 className={styles.text}>{carouselHeader}</h4>
        <Carousel className={styles.carousel} slides={slides} />
      </section>
      <ImageNavigation home />
      <Article header="TECHNOLOGY AT WORK" content={articleContent} bg="dark" />
    </div>
  );
};

export default Home;
